import { useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useEventEmailFolders } from '../hooks/useEventEmailFolders';
import { EmailBoxContext } from './EmailBoxContext';
import { useContactDetails } from './ContactDetailsContext';

// eslint-disable-next-line import/prefer-default-export
export const ContactEmaillBoxContextProvider = () => {
  const { id: contactId } = useParams();
  const { unreadMessagesProps } = useContactDetails();
  const contactIds = useMemo(() => (contactId ? [Number(contactId)] : []), [contactId]);
  const value = useEventEmailFolders(contactIds, unreadMessagesProps);

  return (
    <EmailBoxContext.Provider value={value}>
      <Outlet />
    </EmailBoxContext.Provider>
  );
};
